
<div class="mx-auto h-screen w-full banner relative lg:p-0">
    <app-navbar-new class="absolute"></app-navbar-new>
    <app-banner></app-banner>
</div>
<app-sub-banner></app-sub-banner>
<app-why-us></app-why-us>
<app-launch-crypto></app-launch-crypto>
<app-explore-ecosystem></app-explore-ecosystem>
<app-token-features></app-token-features>
<app-nft-features></app-nft-features>
<app-upcoming></app-upcoming>
<app-bx-infinity-chain></app-bx-infinity-chain>
<app-next-features></app-next-features>
<app-roadmap></app-roadmap>
<!-- <app-our-team></app-our-team> -->
<app-our-blog></app-our-blog>
<!-- <app-news-events></app-news-events> -->
<app-partners></app-partners>
<app-contact-us id="contact-us"></app-contact-us>
<app-footer></app-footer>



